import { createSlice } from "@reduxjs/toolkit";
import { getWebpages } from "./_webpageAction";

const initialState: any = {
  data: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const webpageList = createSlice({
  name: "webpageList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getWebpages.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getWebpages.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getWebpages.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
